<div class="row ml-1 mt-2">
  <div class="col">
    <small><a [routerLink]="['/dealer']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/customers']" class="text-secondary"> Customers</a></small>
    <small><a [routerLink]="['/corporate']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/customers']" class="text-secondary"> Customers</a></small>
  </div>
</div>

<!-- <div class="row pl-3 pr-3 pb-3 pt-2"> -->
<div class="row pt-2">
  <div class="col-sm-12"><button type="button" class="btn btn-primary float-right" data-toggle="modal"
      data-target="#addCustomer" data-backdrop="static" data-keyboard="false">Add Customer
      <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
    </button></div>

  <div class="table-responsive col-sm-12 mt-3 pb-3">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <th scope="col" width="10%" class="text-center">
            <!-- <button class="btn btn-outline-danger pt-0 pb-0"
              [disabled]="selectedAdmins.length < 1" data-toggle="modal" data-target="#deleteAdmin"><i
                class="fa fa-trash"></i></button> -->
          </th>
          <th scope="col" width="12%" class=""></th>
          <th scope="col" width="16%" class="d-none d-sm-table-cell">Name</th>
          <th scope="col" class="d-table-cell d-sm-none">Name</th>
          <th scope="col" width="21%" class="d-none d-sm-table-cell">Email</th>

          <th scope="col" width="14%" class="d-none d-sm-table-cell">Phone</th>

          <!-- <th scope="col" class="pr-0">Status</th> -->
          <!-- <th scope="col" width="10%">Roles</th>
          <th scope="col" width="17%" class="d-none d-sm-table-cell">Vehicles</th> -->
          <th scope="col" width="27%" class="d-none d-sm-table-cell">Vehicles</th>
        </tr>
      </thead>
      <tbody class="max-height-57">
        <tr *ngFor="let customer of customers; let i = index">
          <th width="10%" scope="row" class="text-center pr-0">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" name="checkbox" class="custom-control-input" [disabled]="customer.id == loggedInUserId"
                id="customer_{{i}}" (change)="onCustomerSelected(customer.id)">
              <label class="custom-control-label" for="customer_{{i}}"></label>
            </div>
          </th>
          <td width="12%" class="cursor-pointer text-center pl-0" [routerLink]="['/customer/detail']"
            (click)="navigateToDetailPage(customer)">
            <!-- <img class="home-grid-image" src="{{customer.avatar}}" alt="{{customer.name}}" /> -->
            <img *ngIf="customer.image" class="home-grid-image" src="{{customer.image}}" alt="{{customer.name}}" />
            <img *ngIf="!customer.image" class="home-grid-image" src="assets/images/user_male.png" alt="{{customer.name}}" />
            <!-- <i class="fa fa-window-minimize" style="font-size: 1.1rem; line-height: 0px; color: red;"></i> -->
            <br>
            <!-- <i class="fa fa-window-minimize" style="line-height: 0px; color: green;"></i> -->
            <i *ngIf="customer.status=='ACTIVE'" class="fa fa-window-minimize" style="line-height: 0px; color: green;"></i>
            <i *ngIf="customer.status=='INVITED'" class="fa fa-window-minimize"
              style="line-height: 0px; color: rgb(240, 173, 68);"></i>
            <i *ngIf="customer.status=='DISABLED' || customer.status=='INACTIVE'" class="fa fa-window-minimize"
              style="line-height: 0px; color: red"></i>
          </td>

          <td width="16%" class="cursor-pointer d-table-cell d-sm-none" [routerLink]="['/customer/detail']"
            (click)="navigateToDetailPage(customer)">
            <b>{{customer.name}}</b><br>
            <span class="mt-2">{{customer.username}}</span><br>
            <span class="mt-2">{{customer.phone}}</span>
          </td>
          <td class="cursor-pointer d-none d-sm-table-cell" [routerLink]="['/customer/detail']"
            (click)="navigateToDetailPage(customer)">{{customer.name}}</td>
          <td width="21%" class="cursor-pointer d-none d-sm-table-cell" [routerLink]="['/customer/detail']"
            (click)="navigateToDetailPage(customer)">{{customer.username}}</td>
          <td width="14%" class="cursor-pointer d-none d-sm-table-cell" [routerLink]="['/customer/detail']"
            (click)="navigateToDetailPage(customer)">{{customer.phone}}</td>
          <!-- <td class="cursor-pointer">
            <div *ngFor="let role of customer.roles" [routerLink]="['/customer/detail']"
              (click)="navigateToDetailPage(customer)">{{role | role_display}}</div>
          </td> -->
          <!-- <td class="cursor-pointer" (click)="navigateToDetailPage(customer)" [routerLink]="['/customer/detail']">
            {{customer.lastSignedIn | timeAgo}}</td> -->
          <td width="27%" class="cursor-pointer d-none d-sm-table-cell" [routerLink]="['/customer/detail']"
          (click)="navigateToDetailPage(customer)">
            <div *ngFor="let vehicle of customer.vehicles">{{vehicle.vin}} [{{vehicle.role | role_display}}]</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Modal Add Customer -->
<div class="modal fade" id="addCustomer" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="addCustomerTitle">Add Customer</h5>
        <button id="closeAddCustomer" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetAddCustomerForm()">&times;</span>
        </button>
      </div>
      <form name="customerInfo" #addCustomerForm="ngForm" novalidate (ngSubmit)="onAddCustomer(addCustomerForm)">
        <div class="modal-body">
          <div class="row hide-x-scroll">
            <!-- <div class="col-lg-3 col-md-3 col-sm-3 col-4">
              <input class="hide" #customerPhoto name="customerPhoto" type="file" />
              <button class="btn btn-light rounded-circle upload-img-btn" (click)="customerPhoto.click()">Add
                Image</button>
            </div> -->
            <!-- <div class="col-lg-2 col-md-2 col-sm-3 col-3 pr-0 text-center">
              <div *ngIf="!customerFormData.image">
                <img src="assets/images/person.jpg" class="img-thumbnail full-img">
              </div>
              <div *ngIf="customerFormData.image">
                <img [src]="customerFormData.image" class="img-thumbnail full-img">
              </div>
              <div style="height:0px;overflow:hidden">
                <input #uploadUserLogo id="uploadUserLogoInput" name="uploadUserLogoInput" type="file"
                  (click)="uploadUserLogo.value=null" (change)="uploadFleetB2BLogo($event)" accept=".jpg,.png">
              </div>
              <small><a style="cursor:pointer" (click)="changeuploadFleetB2BLogoClicked()"><u>Upload
                    Image</u></a></small>
            </div> -->
            <div class="col-lg-10 col-md-10 col-sm-9 col-9">
              <div class="form-group">
                <label for="customerName"><span class="maroon  astrisk">&#10033;&nbsp;</span>Name</label>
                <input type="text" class="form-control" id="customerName" name="customerName" placeholder="Name" required
                  [(ngModel)]="customerFormData.name" #customerName="ngModel">
                <small class="text-danger text-center" *ngIf="customerName.errors && addCustomerForm.submitted">
                  <p class="mb-0" *ngIf="customerName.errors.required">*Required</p>
                </small>
              </div>
              <div class="form-group">
                <label for="customerEmail"><span class="maroon  astrisk">&#10033;&nbsp;</span>Email</label>
                <input type="email" class="form-control" id="customerEmail" name="customerEmail" placeholder="Email Address"
                  required [(ngModel)]="customerFormData.customerEmail" #customerEmail="ngModel" pattern="^[^@]+@[^@]+\.[^@]+$">
                <small class="text-danger text-center" *ngIf="customerEmail.errors && addCustomerForm.submitted">
                  <p class="mb-0" *ngIf="customerEmail.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!customerEmail.errors.required">Invalid email</p>
                </small>
              </div>
              <div class="form-group">
                <label for="customerPhone"><span class="maroon  astrisk">&#10033;&nbsp;</span>Phone</label>
                <input type="text" class="form-control" id="customerPhone" pattern="[+][1][0-9]{10}" name="customerPhone"
                  placeholder="+1XXXXXXXXXX" maxlength="12" required [(ngModel)]="customerFormData.customerPhone"
                  #customerPhone="ngModel">
                <small class="text-danger text-center" *ngIf="customerPhone.errors && addCustomerForm.submitted">
                  <p class="mb-0" *ngIf="customerPhone.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!customerPhone.errors.required">Invalid Phone</p>
                </small>
              </div>
              <div class="form-group">
                <label for="vin"><span class="maroon astrisk">&#10033;&nbsp;</span>VIN</label>
                <input type="text" class="form-control" id="vin" name="vin" placeholder="vin" required
                  [(ngModel)]="customerFormData.vin" #vin="ngModel" pattern="[A-Z0-9]{17}" minlength="17">
                <small class="text-danger text-center" *ngIf="vin.errors && addCustomerForm.submitted">
                  <p class="mb-0" *ngIf="vin.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!vin.errors.required">Invalid vin</p>
                </small>
              </div>
              <!-- <div class="form-group">
                <label><span class="maroon astrisk">&#10033;&nbsp;</span>Select Role</label>
                <select id="model" class="w-100" aria-placeholder="Select Role" [(ngModel)]="customerFormData.role"
                  name="role" (change)="relationChanged($event)" #role="ngModel"> 
                  <option *ngFor= "let role of userRoles" value={{role}}>{{role | role_display}}</option>
                </select>
              </div> -->
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetAddCustomerForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary">SAVE & CONTINUE
          &nbsp;<span><i class="fas fa-chevron-right"></i></span></button>
        </div>
      </form>
    </div>
  </div>
</div>

<button id="addDriverButton" type="button" class="btn btn-primary float-right" data-toggle="modal"
      data-target="#addDriver" data-backdrop="static" data-keyboard="false" [hidden]="true" >Add Driver
      Hidden Button
</button>

<!-- Modal Add Family Members -->
<div class="modal fade" id="addDriver" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="addDriverTitle">Add Family Members</h5>
        <button id="closeAddDriver" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetAddDriverForm()">&times;</span>
        </button>
      </div>
      <form name="driverInfo" #addDriverForm="ngForm" novalidate (ngSubmit)="onAddDriver(addDriverForm)">
        <div class="modal-body">
          <div class="row hide-x-scroll">
            <!-- <div class="col-lg-3 col-md-3 col-sm-3 col-4">
              <input class="hide" #customerPhoto name="customerPhoto" type="file" />
              <button class="btn btn-light rounded-circle upload-img-btn" (click)="customerPhoto.click()">Add
                Image</button>
            </div> -->
            <!-- <div class="col-lg-2 col-md-2 col-sm-3 col-3 pr-0 text-center">
              <div *ngIf="!driverFormData.image">
                <img src="assets/images/person.jpg" class="img-thumbnail full-img">
              </div>
              <div *ngIf="driverFormData.image">
                <img [src]="driverFormData.image" class="img-thumbnail full-img">
              </div>
              <div style="height:0px;overflow:hidden">
                <input #uploadUserLogo id="uploadUserLogoInput" name="uploadUserLogoInput" type="file"
                  (click)="uploadUserLogo.value=null" (change)="uploadFleetB2BLogo($event)" accept=".jpg,.png">
              </div>
              <small><a style="cursor:pointer" (click)="changeuploadFleetB2BLogoClicked()"><u>Upload
                    Image</u></a></small>
            </div> -->
            <div class="col-lg-10 col-md-10 col-sm-9 col-9">
              <div class="form-group">
                <label for="driverName"><span class="maroon  astrisk">&#10033;&nbsp;</span>Name</label>
                <input type="text" class="form-control" id="driverName" name="driverName" placeholder="Name" required
                  [(ngModel)]="driverFormData.name" #driverName="ngModel">
                <small class="text-danger text-center" *ngIf="driverName.errors && addDriverForm.submitted">
                  <p class="mb-0" *ngIf="driverName.errors.required">*Required</p>
                </small>
              </div>
              <div class="form-group">
                <label for="driverEmail"><span class="maroon  astrisk">&#10033;&nbsp;</span>Email</label>
                <input type="email" class="form-control" id="driverEmail" name="driverEmail" placeholder="Email Address"
                  required [(ngModel)]="driverFormData.driverEmail" #driverEmail="ngModel" pattern="^[^@]+@[^@]+\.[^@]+$">
                <small class="text-danger text-center" *ngIf="driverEmail.errors && addDriverForm.submitted">
                  <p class="mb-0" *ngIf="driverEmail.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!driverEmail.errors.required">Invalid email</p>
                </small>
              </div>
              <div class="form-group">
                <label for="driverPhone"><span class="maroon  astrisk">&#10033;&nbsp;</span>Phone</label>
                <input type="text" class="form-control" id="driverPhone" pattern="[+][1][0-9]{10}" name="driverPhone"
                  placeholder="+1XXXXXXXXXX" maxlength="12" required [(ngModel)]="driverFormData.driverPhone"
                  #driverPhone="ngModel">
                <small class="text-danger text-center" *ngIf="driverPhone.errors && addDriverForm.submitted">
                  <p class="mb-0" *ngIf="driverPhone.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!driverPhone.errors.required">Invalid Phone</p>
                </small>
              </div>
              <div class="form-group">
                <label for="relationship"><span class="maroon astrisk">&#10033;&nbsp;</span>Select Relationship</label>
                <select id="model" class="w-100" id="relationship" aria-placeholder="Select Relationship"
                  [(ngModel)]="driverFormData.relationship" name="relationship" (change)="relationChanged($event)" #role="ngModel">
                  <option value="SPOUSE">Spouse</option>
                  <option value="FATHER">Father</option>
                  <option value="MOTHER">Mother</option>
                  <option value="SIBLING">Sibling</option>
                  <option value="SON">Son</option>
                  <option value="DAUGHTER">Daughter</option>
                  <option value="FRIENDS">Friends</option>
                  <option value="OTHERS">Others</option>
                </select>
              </div>
              <!-- <div class="form-group">
                <label><span class="maroon astrisk">&#10033;&nbsp;</span>Select Role</label>
                <select id="model" class="w-100" aria-placeholder="Select Role" [(ngModel)]="driverFormData.role"
                  name="role" (change)="relationChanged($event)" #role="ngModel"> 
                  <option *ngFor= "let role of userRoles" value={{role}}>{{role | role_display}}</option>
                </select>
              </div> -->
              <label class="mt-3"><span class="maroon astrisk">&#10033;&nbsp;</span>Minor</label>
              <div class="row mt-1">
                <div class="col">
                  <div class="form-group mb-0">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" id="isMinor" name="isMinor"
                      [(ngModel)]="driverFormData.isMinor" [value]="true">
                      <label class="custom-control-label" for="isMinor">Yes</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" id="isAdult" name="isMinor"
                      [(ngModel)]="driverFormData.isMinor" [value]="false">
                      <label class="custom-control-label" for="isAdult">No</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetAddDriverForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">SAVE</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal Delete Admin -->
<div class="modal fade" id="deleteAdmin" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="deleteAdminTitle">Delete User(s)</h5>
        <button type="button" class="close" (click)="cancelDeleteUser()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <h5 class="mt-5 mb-5">Confirm deleting selected user(s) ?</h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" (click)="cancelDeleteUser()" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" data-dismiss="modal" (click)="onDeleteAdmins()">OK</button>
      </div>
    </div>
  </div>
</div>